"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertComponentOverrides = convertComponentOverrides;
exports.sortComponentOverrideProblems = sortComponentOverrideProblems;
const shared_1 = require("@buildwithflux/shared");
const pcb_1 = require("../../pcb");
const reviews_1 = require("../../reviews");
const common_1 = require("./common");
function convertComponentOverrides(nodes, pcbLayoutRuleSets) {
    return (problem) => {
        const designatorUidMap = {};
        const filteredNodes = problem.affectedItems
            .filter(({ type }) => type !== "ruleSet")
            .map((a) => nodes[a.uid])
            .filter(Boolean);
        // Silk nodes (text, line, circle, rectangle) and 3D model nodes are non-critical
        const isOnlyNonCriticalNodesAffected = filteredNodes.every((node) => node.type === pcb_1.PcbNodeTypes.text ||
            node.type === pcb_1.PcbNodeTypes.line ||
            node.type === pcb_1.PcbNodeTypes.circle ||
            node.type === pcb_1.PcbNodeTypes.rectangle ||
            node.type === pcb_1.PcbNodeTypes.model);
        const designator = filteredNodes.length
            ? filteredNodes
                .map((node) => {
                if (node.type === pcb_1.PcbNodeTypes.pad) {
                    const componentUid = node.uid.split("_")[0] ?? "";
                    const component = (0, common_1.getLabelForPcbNode)(nodes[componentUid]);
                    const padBakedNode = node;
                    const terminalId = padBakedNode.terminalId;
                    const nodeLabel = (0, common_1.getLabelForPcbNode)(node);
                    let pinInfo;
                    if (nodeLabel && nodeLabel.trim() !== "") {
                        pinInfo = nodeLabel;
                    }
                    else if (terminalId && terminalId.trim() !== "") {
                        pinInfo = terminalId;
                    }
                    else {
                        const affectedItem = problem.affectedItems.find((item) => item.uid === node.uid);
                        if (affectedItem?.itemLabel && affectedItem.itemLabel.trim() !== "") {
                            pinInfo = affectedItem.itemLabel;
                        }
                        else {
                            pinInfo = node.uid.substring(0, 8);
                        }
                    }
                    const designator = (0, common_1.sanitizeDesignator)(`${component}:${pinInfo}`);
                    designatorUidMap[designator] = node.uid;
                    return designator;
                }
                else {
                    const affectedItem = problem.affectedItems.find((item) => item.uid === node.uid);
                    const designator = (0, common_1.sanitizeDesignator)((0, common_1.getLabelForPcbNode)(node) ?? affectedItem?.itemLabel);
                    designatorUidMap[designator] = node.uid;
                    return designator;
                }
            })
                .join(", ")
            : null;
        const ruleSet = problem.affectedItems
            .filter(({ type }) => type === "ruleSet")
            .map((a) => {
            const designator = (0, common_1.sanitizeDesignator)((0, common_1.getLabelForRuleSet)(a.uid, pcbLayoutRuleSets));
            if (designator) {
                designatorUidMap[designator] = a.uid;
            }
            return designator;
        })
            .join(", ");
        return {
            name: designator ?? null,
            designator: designator,
            ruleSet: ruleSet,
            status: isOnlyNonCriticalNodesAffected ? reviews_1.ReviewStatus.INFORMATIONAL : reviews_1.ReviewStatus.WARNING,
            designatorUidMap,
        };
    };
}
function sortComponentOverrideProblems(problems, nodes, pcbLayoutRuleSets) {
    const converter = convertComponentOverrides(nodes, pcbLayoutRuleSets);
    const sortedProblems = [...problems].sort((a, b) => {
        const itemA = converter(a);
        const itemB = converter(b);
        const statusA = itemA.status ?? reviews_1.ReviewStatus.ERROR;
        const statusB = itemB.status ?? reviews_1.ReviewStatus.ERROR;
        const severityDiff = (reviews_1.priorityMap[statusB] ?? 0) - (reviews_1.priorityMap[statusA] ?? 0);
        if (severityDiff !== 0) {
            return severityDiff;
        }
        const designatorA = itemA.designator ?? "zzz_none";
        const designatorB = itemB.designator ?? "zzz_none";
        return (0, shared_1.naturalSortByProperty)("designator")({ designator: designatorA }, { designator: designatorB });
    });
    return { sortedProblems, converter };
}
//# sourceMappingURL=componentOverrides.js.map